<template>
  <ElForm class="elementui-common-form-styles" v-highlight label-width="50" inline>
    <ElFormItem>
      <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 200px" @keyup.enter.native="search">
        <i slot="append" @click="search" class="el-icon-search"></i>
      </ElInput>
    </ElFormItem>
    <ElFormItem label="状态">
      <ElSelect v-model="taskStatus" style="width: 80px" @change="sendEvent">
        <el-option :value="-1" label="不限"></el-option>
        <el-option :value="0" label="未开始"></el-option>
        <el-option :value="1" label="进行中"></el-option>
        <el-option :value="2" label="成功"></el-option>
        <el-option :value="3" label="失败"></el-option>
      </ElSelect>
    </ElFormItem>
    <ElFormItem label="媒体">
      <ElSelect v-model="mediaId" style="width: 100px" @change="onMediaChange">
        <el-option :value="-1" label="不限"></el-option>
        <el-option :value="10" label="巨量引擎"></el-option>
        <el-option :value="16" label="腾讯"></el-option>
        <el-option :value="32" label="磁力引擎"></el-option>
        <el-option :value="6" label="超级汇川"></el-option>
        <el-option :value="45" label="百度信息流"></el-option>
      </ElSelect>
    </ElFormItem>

    <ElFormItem label="媒体版本">
      <el-select v-model="version" style="width: 100px" collapse-tags clearable @change="sendEvent">
        <el-option v-for="item in versions[mediaId] || []" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </ElFormItem>

    <ElFormItem label="账号">
      <ElSelect v-model="accountId" clearable filterable @change="sendEvent">
        <el-option v-for="item in MEDIA_ACCOUNTS" :value="item.id" :label="item.name" :key="item.id"></el-option>
      </ElSelect>
    </ElFormItem>

    <ElFormItem label="游戏">
      <ElSelect v-model="gameId" clearable filterable @change="sendEvent">
        <el-option v-for="item in GAMES" :value="item.id" :label="item.name" :key="item.id"></el-option>
      </ElSelect>
    </ElFormItem>

    <ElFormItem label="提交人">
      <ElSelect v-model="opId" style="width: 100px" filterable clearable @change="sendEvent">
        <el-option v-for="item in PTOM_USERS" :value="item.id" :label="item.name" :key="item.id"></el-option>
      </ElSelect>
    </ElFormItem>

    <ElButton type="primary" style="margin-right: 3px" @click="search">查询</ElButton>

    <DropdownNavigator style="margin-left: 3px" button-text="批量新建计划" button-type="none"></DropdownNavigator>

    <ElButton class="btns" @click="$emit('on-edit')">批量失败修改</ElButton>
    <ElButton class="btns" @click="$emit('on-retry')">批量重试</ElButton>
    <ElButton class="btns" @click="$emit('on-duplicate')">批量复制</ElButton>
  </ElForm>
</template>
<script>
import Cookies from 'js-cookie'
import { initPageData, GAMES, MEDIA_ACCOUNTS, PTOM_USERS } from '@/data/global-opts'
import DropdownNavigator from '@/components/new-plan-dropdown-nav/index.vue'

// 当前页面需要的下拉数据项 ref: src\data\global-opts.js
const PAGE_REQUIRED_OPTS = initPageData([GAMES, MEDIA_ACCOUNTS, PTOM_USERS])
const opId = Cookies.get('ch_op_id')
export default {
  name: 'batchadFilter',
  props: {
    placeholder: {
      type: String
    }
  },
  components: {
    DropdownNavigator
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    buildParams() {
      const params = {
        adAccountId: this.accountId === '' ? undefined : this.accountId,
        gameId: this.gameId === '' ? undefined : this.gameId,
        opId: this.opId === '' ? undefined : this.opId,
        mediaId: this.mediaId === '' ? undefined : this.mediaId,
        version: this.version === '' ? undefined : this.version,
        taskStatus: this.taskStatus,
        planName: this.keyword === '' ? undefined : this.keyword
      }

      return params
    },
    onMediaChange() {
      this.version = ''
      this.sendEvent()
    },
    sendEvent() {
      const params = this.buildParams()
      this.$emit('on-change', params)
    },
    search() {
      const params = this.buildParams()
      this.$emit('on-search', params)
    },

    dropClick(name) {
      if (name === 'tencent') this.$emit('on-add', 16)
      else if (name === 'tencent-ada') this.$emit('on-add-new', 16)
      else if (name === 'toutiao') this.$emit('on-add', 10)
      else if (name === 'kuaishou') this.$emit('on-add', 32)
      else if (name === 'baidu') this.$emit('on-add', 45)
      else if (name === 'toutiao2') this.$emit('on-add-new', 10)
      else if (name === 'uc') this.$emit('on-add', 6)
    }
  },
  data() {
    return {
      gameId: '', // 游戏id
      mediaId: '', // 媒体id
      opId: Number(opId), // 人员id
      accountId: '', // 账号
      taskStatus: -1, // 状态
      keyword: '',
      version: '',
      versions: {
        10: [
          { id: 'Ttv3', name: '巨量引擎2.0' },
          { id: 'TtJubao', name: '巨量智擎' }
        ],
        16: [
          { id: 'v1', name: '腾讯v1' },
          { id: 'GDT-ADA', name: '腾讯ADA' },
          { id: 'Gdtv3', name: '腾讯v3' }
        ]
      }
    }
  },
  created() {
    this.search()
  }
}
</script>

<style lang="scss" scoped>
.btns {
  margin-left: 3px;
}
</style>
